import React from "react";
import "../../../main.css";
import "./EmptyViewCard.css";
import { Card, Image } from "../../common/utils/antd-imports/AntdImports";
import noCampaignImage from "../../../assests/no-campaign.svg";

const NoCampaignsCard = ({ header, text, state }) => {
  return (
    <div className="no-data-container">
      <Card title="" className="no-data-card">
        <span className="card-inside-section">
          <Image
            src={noCampaignImage}
            alt="no-campaigns"
            className="empty-view-image"
            preview={false}
          />
          {state ? (
            <>
              {" "}
              <div className="no-records-text header-text">{header} !</div>
            </>
          ) : (
            <div className="no-records-text header-text">No {header} Yet!</div>
          )}

          <span className="card-sub-text">{text}</span>
        </span>
      </Card>
    </div>
  );
};

export default NoCampaignsCard;
